<template>
  <div class="promo-design-group">
    <RfHtmlFieldEditor
      v-model="currentActions.rf_settings_privacy_policy_text"
      density="compact"
      label="Terms of Service text"
      :enhancedHtml="isEnhancedHTMLActive(model, appsStore.app)"
      :disabled="currentTranslations.hasOwnProperty('rf_settings_privacy_policy_text')"
      :rows="3"
    />
    <RfInsertUserTrait
      v-if="!currentTranslations.hasOwnProperty('rf_settings_privacy_policy_text')"
      actionName="rf_settings_privacy_policy_text"
      title="legal text"
      :actions="currentActions"
      :app="appsStore.app"
    />
    <RfRetentionInsertLink
      v-model="currentActions.rf_settings_privacy_policy_text"
      title="Terms of Service text"
      textPlaceholder="Terms of Service"
      urlPlaceholder="http://company.com/terms"
      :deviceType="model.device_type"
      :insertColor="currentActions.rf_settings_fill_color"
    />
  </div>
</template>
<script>
import LanguagePreviewMixin from "@/utils/LanguagePreviewMixin";
import RfRetentionInsertLink from "./components/RfRetentionInsertLink.vue";
import RfInsertUserTrait from "@/components/RfPathCreate/RfRetentionActions/RfInsertUserTrait.vue";
import RfHtmlFieldEditor from "@/components/RfPathCreate/RfRetentionActions/components/RfHtmlFieldEditor.vue";
import { isEnhancedHTMLActive } from "@/utils/prompts/promptHelpers";
import { useAppsStore } from "@/pinia/appsStore";

export default {
  name: "RfRetentionActionsLinks",
  components: { RfRetentionInsertLink, RfInsertUserTrait, RfHtmlFieldEditor },
  mixins: [LanguagePreviewMixin],
  props: ["actions", "model"],
  setup: () => ({ appsStore: useAppsStore(), isEnhancedHTMLActive }),
  data() {
    return {
      showInsertLinkDialog: false,
      linkURLToInsert: null,
      linkTextToInsert: null,
    };
  },
  computed: {
    currentActions() {
      return this.currentTranslations.hasOwnProperty("rf_settings_privacy_policy_text")
        ? this.previewActions
        : this.actions;
    },
  },
};
</script>
